/**
 * Italian language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_IT_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Mio profilo',
    'lvt.menu.tw_profile': 'Profilo TW',
    'lvt.menu.company_profile': 'Profilo dell\'azienda',
    'lvt.menu.my_notifications': 'Mie notifiche',
    'lvt.menu.sign_out': 'Disconnettarsi',

    // footer
    'lvt.footer.back_to_top': 'Ritornare all\'inizio',
    'lvt.footer.terms_of_use': 'Condizioni d\'Uso',
    'lvt.footer.privacy_policy': 'Informativa sulla Privacy',
    'lvt.footer.support_information': 'Informazioni di assistenza',
    'lvt.footer.transwide_home': 'Home Transwide',
    'lvt.footer.license_nr': 'N. Licenza:',
    'lvt.footer.build_version': 'Versione',

    // order list columns
    'lvt.order_list.header': 'Elenco ordini',
    'lvt.order_list.column.shipperCompany': 'Azienda di spedizione',
    'lvt.order_list.column.reference': 'Riferimento',
    'lvt.order_list.column.status': 'Stato',
    'lvt.order_list.column.statusReason': 'Motivo status',
    'lvt.order_list.column.senderCompany': 'Azienda mittente',
    'lvt.order_list.column.senderZipcode': 'Codice postale mittente',
    'lvt.order_list.column.senderCity': 'Città del mittente',
    'lvt.order_list.column.receiverCompany': 'Azienda destinataria',
    'lvt.order_list.column.receiverZipcode': 'Codice postale destinatario',
    'lvt.order_list.column.receiverCity': 'Città destinatario',
    'lvt.order_list.column.carrierName': 'Nome vettore',
    'lvt.order_list.column.plannedPickupEndDate': 'Ritiro programmato',
    'lvt.order_list.column.etaPickup': 'ETA al ritiro',
    'lvt.order_list.column.delayAtPickup': 'Ritardo al ritiro',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Consegna programmata',
    'lvt.order_list.column.etaDelivery': 'ETA alla consegna',
    'lvt.order_list.column.delayAtDelivery': 'Ritardo alla consegna',
    'lvt.order_list.column.timestamps': 'Marca temporale',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Richiesto',
    'lvt.order_list.status.failed': 'Errore',
    'lvt.order_list.status.waiting': 'In attesa',
    'lvt.order_list.status.active': 'Attivo',
    'lvt.order_list.status.stopped': 'Errore',
    'lvt.order_list.status.completed': 'Completato',
    'lvt.order_list.status.cancelled': 'Annullato',
    'lvt.order_list.status.timeout': 'Interrotto',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Vettore non assegnato',
    'lvt.order_list.status_reason.plate_number_not_present': 'Numero di targa non presente',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Numero di targa non riconosciuto',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Numero di targa non operativo',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'righe per pagina',
    'lvt.order_list.pagination.first': 'Primo',
    'lvt.order_list.pagination.previous': 'Precedente',
    'lvt.order_list.pagination.next': 'Successivo',
    'lvt.order_list.pagination.last': 'Ultimo',
    'lvt.order_list.pagination.no_orders_found': 'Ordine non trovato',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Rimorchio',
    'lvt.map.tracked_device.tractor': 'Trattore',
    'lvt.map.tracked_device.mobile': 'Mobile',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Apri elenco ordini',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Ritiro',
    'lvt.map.pickup_popup.date': 'Data',
    'lvt.map.pickup_popup.address': 'Indirizzo',
    'lvt.map.delivery_popup.delivery': 'Consegna',
    'lvt.map.delivery_popup.date': 'Data',
    'lvt.map.delivery_popup.address': 'Indirizzo',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'In transito per consegna',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'In transito per ritiro',
    'lvt.map.current_gps_popup.current_speed': 'Velocità attuale',
    'lvt.map.current_gps_popup.average_speed': 'Velocità media',
    'lvt.map.current_gps_popup.last_location_update': 'Aggiornamento ultima localizzazione',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Orario programmato',
    'lvt.map.current_gps_popup.arrival_delay': 'Ritardo in arrivo',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Arrivato all\'origine',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Non arrivato all\'origine',
    'lvt.order_list.timestamp.left_origin': 'Lasciato l\'origine',
    'lvt.order_list.timestamp.not_left_origin': 'Non lasciato l\'origine',
    'lvt.order_list.timestamp.arrived_at_destination': 'Arrivato a destinazione',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Non arrivato a destinazione',
    'lvt.order_list.timestamp.left_destination': 'Lasciato destinazione',
    'lvt.order_list.timestamp.not_left_destination': 'Non lasciato la destinazione',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-it.ts